/* ===========================
   CWC Social Proof Carousel
   =========================== */

document.addEventListener("DOMContentLoaded", function () {
  const carousels = document.querySelectorAll(".cwc_social-proof-carousel");

  carousels.forEach((carousel) => {
    const track = carousel.querySelector(".cwc_carousel-track");
    if (!track) return;

    // Get speed from data attribute (set in Liquid from schema setting)
    // Default to 50 if not set
    const PIXELS_PER_SECOND = parseInt(carousel.dataset.speed) || 50;

    function setAnimationDuration() {
      // The track has items duplicated 4x for seamless looping
      // The CSS animation moves -50% (half the track width)
      // So we calculate duration based on the distance traveled (50% of track)
      const distanceTraveled = track.scrollWidth / 2;
      
      // Calculate duration: distance / speed = time in seconds
      const duration = distanceTraveled / PIXELS_PER_SECOND;
      
      // Set the animation duration
      track.style.animationDuration = `${duration}s`;
    }

    // Set initial duration after images load
    // Wait for images to load to get accurate width
    const images = track.querySelectorAll("img");
    let loadedCount = 0;
    const totalImages = images.length;

    if (totalImages === 0) {
      setAnimationDuration();
    } else {
      images.forEach((img) => {
        if (img.complete) {
          loadedCount++;
          if (loadedCount === totalImages) {
            setAnimationDuration();
          }
        } else {
          img.addEventListener("load", () => {
            loadedCount++;
            if (loadedCount === totalImages) {
              setAnimationDuration();
            }
          });
        }
      });

      // Fallback: set duration after short delay even if images haven't loaded
      setTimeout(setAnimationDuration, 500);
    }

    // Recalculate on resize (debounced)
    let resizeTimeout;
    window.addEventListener("resize", function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(setAnimationDuration, 200);
    });

    // Pause on hover
    track.addEventListener("mouseenter", () => {
      track.style.animationPlayState = "paused";
    });

    track.addEventListener("mouseleave", () => {
      track.style.animationPlayState = "running";
    });
  });
});